import {onError} from '@apollo/client/link/error';
import {store} from '../store/store';
import {logout} from '../store/slices/exchange_token_slice';
import {toast} from 'react-toastify';
import {ServerError} from '@apollo/client';

let isLoggingOut = false;

export const createErrorLink = () => {
    return onError(({graphQLErrors, networkError}) => {
        const statusCode = (networkError as ServerError)?.statusCode;

        if (networkError && (statusCode === 401 || networkError.message?.includes('401'))) {
            isLoggingOut = true;

            store.dispatch(logout());

            toast.warning('Uw sessie is verlopen. Log opnieuw in', {
                position: 'top-right',
                autoClose: 5000,
                pauseOnHover: false,
                closeOnClick: true,
                toastId: 'logout-401',
            });

            setTimeout(() => {
                window.location.href = '/login';
            }, 2500);

            return;
        }

        if (isLoggingOut) {
            return;
        }

        if (graphQLErrors) {
            graphQLErrors.forEach(({message, locations, path}) => {
                console.error(`GraphQL error: ${message}`, {locations, path});
            });
        }

        if (networkError) {
            console.error('Network error details:', networkError);
        }
    });
};
